import React, { useCallback, useEffect, useState } from "react";
import ChatTitle from "../chat-title/Chat-Title";
import MessageList from "../message/Message-List";
import ChatForm from "../chat-form/Chat-Form";
import firebase from "firebase/app";
import "firebase/firestore";
import LinearProgress from "@mui/material/LinearProgress";

import "./Chat-Shell.css";

let unsubscribe;

function ChatShell({ consultaId, tipo, userName, uid }) {
  const db = firebase.firestore();
  const [messages, setMessages] = useState([]);
  const [progress, setProgress] = React.useState(0);
  const [isUpdateImage, setIsUpdateImage] = React.useState(false);

  const observableFirestore = useCallback(async () => {
    // const currentDate = new Date();
    unsubscribe = db
      .collection("videollamadas")
      .doc(consultaId)
      .collection("messages")
      .orderBy("instante", "desc")
      .onSnapshot((snaptshot) => {
        console.log(snaptshot.docs.map((doc) => doc.data()));
        setMessages(snaptshot.docs.map((doc) => doc.data()));
      });
  }, [db, consultaId]);

  useEffect(() => {
    observableFirestore();
    return () => {
      unsubscribe();
    };
  }, [observableFirestore]);

  useEffect(() => {
    if (progress === 100) {
      setProgress(0);
      setIsUpdateImage(false);
    }
  }, [progress]);

  return (
    <div id="chat-container">
      <ChatTitle />
      <MessageList tipo={tipo} messages={messages} />
      {!isUpdateImage ? null : <LinearProgress />}
      <ChatForm tipo={tipo} setProgress={setProgress} setIsUpdateImage={setIsUpdateImage} consultaId={consultaId} uid={uid} userName={userName} />
    </div>
  );
}

export default ChatShell;
